import React from "react";

type ChangeRadioValue = (event: any) => any | Promise<any>;

type RadioButtonProps = {
  onChangeValue: ChangeRadioValue;
  values: {
    value: string;
  }[];
};

export const RadioButton = ({ onChangeValue, values }: RadioButtonProps) => {
  return (
    <div
      onChange={onChangeValue}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginTop: 20,
      }}
    >
      {values.map((value, index) => (
        <div key={index} style={{ justifyContent: "center", alignItems: "center" }}>
          <label>
            <input style={{ marginRight: 15, marginBottom: 10 }} type="radio" value={value.value} name="gender" />
            {value.value}
          </label>
        </div>
      ))}
    </div>
  );
};
